import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { urlBaseAgendamento, urlDomain } from "../../../utils/services/config";
import { getMe } from "../../../utils/services/loginUser";

export default function ModalLinksEmbeded(props) {
  const { isOpen, toggle, eventId } = props;
  const [profile, setProfile] = useState("");

  async function clipBoard(url) {
    await navigator.clipboard.writeText(url);
    alert("O link foi copiado para a área de transferência");
  }

  async function getProfile() {
    const res = await getMe();
    if (res?.data?.id) {
      setProfile(res.data.id);
    }
  }

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true}>
      <ModalHeader toggle={toggle}>Links Para Embedar</ModalHeader>
      <ModalBody>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <label className="form-label">
              URL logística Inteegra Plus para o Hall
              <i
                className="mdi mdi-content-copy"
                style={{
                  color: "grey",
                  fontSize: 17,
                  marginLeft: 10,
                  cursor: "pointer",
                }}
                title="Copiar"
                onClick={() =>
                  clipBoard(
                    `https://mobile-site-logistics.${urlDomain}/Tickets/?userId={CODIGOINTERNO}&eventId=${eventId}&color=0000ff`,
                  )
                }
              />
            </label>
            <input
              className="form-control"
              disabled
              value={`https://mobile-site-logistics.${urlDomain}/Tickets/?userId={CODIGOINTERNO}&eventId=${eventId}&color=0000ff`}
            />
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <label className="form-label">
              URL logística Inteegra Plus para o APP Eventos
              <i
                className="mdi mdi-content-copy"
                style={{
                  color: "grey",
                  fontSize: 17,
                  marginLeft: 10,
                  cursor: "pointer",
                }}
                title="Copiar"
                onClick={() =>
                  clipBoard(
                    `https://mobile-site-logistics.${urlDomain}/Tickets/?userId={PAXID}&eventId=${eventId}&color=0000ff`,
                  )
                }
              />
            </label>
            <input
              className="form-control"
              disabled
              value={`https://mobile-site-logistics.${urlDomain}/Tickets/?userId={PAXID}&eventId=${eventId}&color=0000ff`}
            />
          </Col>
        </Row>

        {profile === process.env.REACT_APP_PMCODE && (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <label className="form-label">
                URL logística do MICE
                <i
                  className="mdi mdi-content-copy"
                  style={{
                    color: "grey",
                    fontSize: 17,
                    marginLeft: 10,
                    cursor: "pointer",
                  }}
                  title="Copiar"
                  onClick={() =>
                    clipBoard(
                      `https://mobile-site-logistics.sistemasinteegra.com.br/ticketsmice/?userId={ID do Participante}&eventId={ID do Evento}&color=0000ff`,
                    )
                  }
                />
              </label>
              <input
                className="form-control"
                disabled
                value={`https://mobile-site-logistics.sistemasinteegra.com.br/ticketsmice/?userId={ID do Participante}&eventId={ID do Evento}&color=0000ff`}
              />
            </Col>
          </Row>
        )}
      </ModalBody>
    </Modal>
  );
}
